import { render, staticRenderFns } from "./RptRequerimientosComponent.vue?vue&type=template&id=28a3d476&"
import script from "./RptRequerimientosComponent.vue?vue&type=script&lang=js&"
export * from "./RptRequerimientosComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports